import Keycloak from 'keycloak-js';

const { actions } = require('xstate');
const { assign } = actions;

export const saveError = assign({
  error: (context, event) => {
    console.log('Saving error', event?.error || event?.data?.error);
    return event?.error || event?.data?.error;
  },
});

export const createKeycloakClient = assign({
  keycloak: (context, event) => {
    const kc = new Keycloak({
      url: context.url,
      realm: context.realm,
      clientId: context.clientId,
    });

    return kc;
  },
});

export const saveUserProfile = assign({
  profile: (context, event) => {
    console.log('Saving user profile', event.data);
    return event.data;
  },
});

export const saveRemainingTime = assign({
  remainingTime: (context, event) => {
    const remainingTime = context.keycloak.tokenParsed.exp - Date.now() / 1000;
    console.log(`Token remaining time: ${remainingTime} seconds`);
    return Math.floor(remainingTime);
  },
});

export const resetRemainingTime = assign({
  remainingTime: () => 0,
});

export const incrementRetryRefreshAttempt = assign({
  retryRefreshAttempts: (context, event) => {
    console.log('Incrementing retry refresh attempts');
    return context.retryRefreshAttempts + 1;
  },
});

export const resetRetryRefreshAttempt = assign({
  retryRefreshAttempts: () => 0,
});
